import { cloneDeep } from "es-toolkit";

import { WeeklySubprogram } from "@/domains/v4b/program/subprogram.types";
import { EDay } from "@/utils/date";

export const PROGRAM_WORKING_DAYS = [EDay.MONDAY, EDay.TUESDAY, EDay.WEDNESDAY, EDay.THURSDAY, EDay.FRIDAY] as const;
export const PROGRAM_WEEKEND_DAYS = [EDay.SATURDAY, EDay.SUNDAY] as const;
export const PROGRAM_DAYS = [...PROGRAM_WORKING_DAYS, ...PROGRAM_WEEKEND_DAYS] as const;

export function getDuplicateTargetDays(sourceDay: EDay): EDay[] {
  return PROGRAM_DAYS.filter((day) => day !== sourceDay);
}

export function toggleDuplicateTargetDay(selectedDays: readonly EDay[], day: EDay): EDay[] {
  return selectedDays.includes(day)
    ? selectedDays.filter((selectedDay) => selectedDay !== day)
    : [...selectedDays, day];
}

export function isDuplicateTargetGroupSelected(
  selectedDays: readonly EDay[],
  groupDays: readonly EDay[],
  sourceDay: EDay,
): boolean {
  const availableGroupDays = groupDays.filter((day) => day !== sourceDay);

  return (
    selectedDays.length === availableGroupDays.length && availableGroupDays.every((day) => selectedDays.includes(day))
  );
}

export function toggleDuplicateTargetGroup(
  selectedDays: readonly EDay[],
  groupDays: readonly EDay[],
  sourceDay: EDay,
): EDay[] {
  const availableGroupDays = groupDays.filter((day) => day !== sourceDay);

  return isDuplicateTargetGroupSelected(selectedDays, groupDays, sourceDay) ? [] : availableGroupDays;
}

export function duplicateDayProgram(
  program: WeeklySubprogram,
  sourceDay: EDay,
  targetDays: readonly EDay[],
): WeeklySubprogram {
  const sourceProgram = cloneDeep(program[sourceDay]);
  const uniqueTargetDays = [...new Set(targetDays)].filter((targetDay) => targetDay !== sourceDay);

  return uniqueTargetDays.reduce<WeeklySubprogram>(
    (updatedProgram, targetDay) => ({
      ...updatedProgram,
      [targetDay]: cloneDeep(sourceProgram),
    }),
    { ...program },
  );
}
